const paginaoficial = {
    ObtenLosMenusYSubmenusDeLaPaginaOficial: 'SICPO/PaginaOficial/ObtenLosMenusYSubmenusDeLaPaginaOficial',
    ObtenLosComunicadosDeLaPaginaOficial: 'SICPO/PaginaOficial/ObtenLosComunicadosDeLaPaginaOficial', 
    ObtenUnContenidoEspecifico: 'SICPO/PaginaOficial/ObtenUnContenidoEspecifico', 
    ObtenElContenidoDeUrgencia: 'SICPO/PaginaOficial/ObtenElContenidoDeUrgencia',
    ObtenLaPaginaWebPorMedioDeURL: 'SICPO/PaginaOficial/ObtenLaPaginaWebPorMedioDeURL',
    ObtenLosContenidosDeUrgencia: 'SICPO/PaginaOficial/ObtenContenidosDeUrgencia',
    ObtenAnunciosDeLaPaginaWeb: 'SICPO/PaginaOficial/GetAnunciosPaginaOficial',
}

export default paginaoficial;


//////////////////
// WEBPACK FOOTER
// ./static/js/api/SICPO/sistema/paginaweb/paginaoficial/paginaoficial.js
// module id = null
// module chunks = 